async function deriveKey(password) {
  // Hash the password to create a 256-bit (32-byte) key
  const hash = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(password),
  );
  return crypto.subtle.importKey("raw", hash, "AES-GCM", false, [
    "encrypt",
    "decrypt",
  ]);
}

export async function encryptData(data, password) {
  const key = await deriveKey(password); // Await the key derivation here
  const iv = crypto.getRandomValues(new Uint8Array(12));

  const encodedData = new TextEncoder().encode(
    typeof data === "string" ? data : JSON.stringify(data),
  );

  const encryptedData = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    encodedData,
  );

  return {
    iv: btoa(String.fromCharCode(...iv)),
    content: btoa(String.fromCharCode(...new Uint8Array(encryptedData))),
  };
}

export async function decryptData(encrypted, password) {
  const key = await deriveKey(password); // Await the key derivation here
  const parsed = JSON.parse(encrypted);
  const iv = Uint8Array.from(atob(parsed.iv), (c) => c.charCodeAt(0));
  const encryptedContent = Uint8Array.from(atob(parsed.content), (c) =>
    c.charCodeAt(0),
  );

  const decryptedData = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv },
    key,
    encryptedContent,
  );

  return new TextDecoder().decode(decryptedData);
}
